// AI-823 Provider that instantiates useTarotTheater and makes its result
// available to the subtree via TarotTheaterContext.
//
// Mount this wrapping the subtree that contains both OracleExistingChat and
// TarotReframeModal so both components share one FSM instance. Pass the same
// UseTarotTheaterOptions that the legacy hook receives (active, streamingDocuments,
// isStreaming, isInBadQuestionState, hasError).
import React, { FC, PropsWithChildren } from 'react'
import { useTarotTheater } from './useTarotTheater'
import type { UseTarotTheaterOptions } from './useTarotTheater'
import { TarotTheaterContext } from './TarotTheaterContext'

export type TarotTheaterProviderProps = PropsWithChildren<UseTarotTheaterOptions>

export const TarotTheaterProvider: FC<TarotTheaterProviderProps> = ({
  children,
  ...options
}) => {
  const value = useTarotTheater(options)
  return (
    <TarotTheaterContext.Provider value={value}>
      {children}
    </TarotTheaterContext.Provider>
  )
}
